import { Component, effect, inject, input } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { Store } from '@ngrx/store';
import { selectHubIsDebtConsolidationEnabled } from '../../../../store/selectors/feature-flag.selector';
import { DebtConsolidationService } from '../../../../services/debt-consolidation.service';
import { OffersService } from '../../../offers/services/offers.service';
import { selectHasExpressHubOffer } from '../../../offers/store/selectors/offers.selectors';

@Component({
  selector: 'app-debt-consolidation-placement',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './debt-consolidation-placement.component.html',
  styleUrl: './debt-consolidation-placement.component.scss'
})
export class DebtConsolidationPlacementComponent {
  offersService = inject(OffersService)
  befhUrl = input<string>('')
  store = inject(Store)
  debtConsolidationService = inject(DebtConsolidationService)
  isDebtConsolidationEnabled = this.store.selectSignal(selectHubIsDebtConsolidationEnabled)
  hasExpressOffer = this.store.selectSignal(selectHasExpressHubOffer)
  url = ''
  shouldShow = false

  constructor() {
    const fetchEffect = effect(() => {
      if (!this.isDebtConsolidationEnabled()) return
      const baseUrl = this.befhUrl()
      if (!baseUrl) return

      const url = new URL(baseUrl)
      url.searchParams.set('next', '/financial-health/debt-manager/debt-consolidation/')
      this.url = decodeURIComponent(url.href)
      this.debtConsolidationService.requestDebtConsolidation()
      fetchEffect.destroy()
    })

    const processEffect = effect(() => {
      this.debtConsolidationService.status();
      const hasExpressOffer = this.hasExpressOffer();

      if (!this.debtConsolidationService.hasValue()) return;

      const response = this.debtConsolidationService.value();
      const interestPaymentBenefit = (response?.offerSummary?.interestPaymentChange ?? 0) < 0;
      const totalMonthlyPaymentBenefit = (response?.offerSummary?.totalMonthlyPaymentChange ?? 0) < 0;
      this.shouldShow = interestPaymentBenefit && hasExpressOffer;

      if (this.shouldShow) {
        this.offersService.trackBefhSeenEvent('hub', {
          displayType: 'DebtConsolidation',
          displayText: 'You could be eligible for smarter debt solutions',
        });
      } else if (hasExpressOffer && totalMonthlyPaymentBenefit && !interestPaymentBenefit) {
        this.offersService.trackBefhSeenEvent('hub', {
          displayType: 'DebtConsolidationMonthlyPaymentBenefit',
          displayText: 'N/A',
        });
      }

      processEffect.destroy();
    });
  }

  fireLinkClickEvent(): void {
    this.offersService.trackNoObjectClickEvent({
      url: this.url,
      config: 'DebtConsolidation',
      placement: '',
      customerPortalClickLinkText: 'See your results',
      siteSection: 'hub',
    });
  }
}
